import { render, staticRenderFns } from "./TagAttribute.vue?vue&type=template&id=8fac6740&scoped=true"
import script from "./TagAttribute.vue?vue&type=script&lang=js"
export * from "./TagAttribute.vue?vue&type=script&lang=js"
import style0 from "./TagAttribute.vue?vue&type=style&index=0&id=8fac6740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fac6740",
  null
  
)

export default component.exports